import React, {useState} from 'react';
import './index.scss';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from '../../hooks/useTranslation';

const Installation = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const {t} = useTranslation();

  const handleChange = e => {
    setChecked(e.target.checked);
  };

  return (
    <div className='installation'>
      <div className='installation__left'>
        <img src='/assets/register-bg.png' alt='bg' />
      </div>
      <div className='installation__right'>
        <div className='installation__box'>
          <div className='installation__box-img'>
            <img src='/assets/installation.png' alt='icon' />
          </div>
          <p className='installation__title'>{t('installation.title')}</p>
          <p className='installation__text'>
            {t('installation.message')}
          </p>
          {/*<div className="auth__checkbox">*/}
          {/*  <input type="checkbox" id="remember" onChange={handleChange} />*/}
          {/*  <label htmlFor="remember">I have read the information</label>*/}
          {/*</div>*/}
          <div style={{height: 16}}></div>
          <button
            className={`installation__btn auth__submit`}
            // disabled={!checked}
            onClick={() => {
              navigate('/login');
            }}
          >
            {t('installation.proceedToLogin')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Installation;
